// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { CustomAppState } from "@west/App/Store/Reducers";
import {
    getSignInCreateNewAccountWidget,
    getSignInExistingAccountWidget,
} from "@west/App/Store/Selectors/WidgetSelectors";

import React, { FC } from "react";

const StyledHr = getStyledWrapper("hr");

interface MiniSignInProps {
    closeSignInTippy: () => void;
}

type Props = MiniSignInProps;

interface MiniSignInStyles {
    container?: InjectableCss;
    divider?: InjectableCss;
    closeClickable?: ClickablePresentationProps;
    closeIcon?: IconPresentationProps;
}

export const miniSignInStyles: MiniSignInStyles = {};

const styles = miniSignInStyles;
const MiniSignIn: FC<Props> = props => {
    const { headerHeight, signInExistingAccountWidgetField, signInExistingAccountField } = useAppSelector(state => {
        return {
            signInExistingAccountWidgetField: getSignInExistingAccountWidget(state),
            signInExistingAccountField: getSignInCreateNewAccountWidget(state),
            headerHeight: (state as CustomAppState).xHeader.headerHeight,
        };
    });
    return (
        <StyledWrapper {...styles.container} {...{ headerHeight }} data-test-selector="mini-signIn">
            <Clickable
                {...styles.closeClickable}
                onClick={props.closeSignInTippy}
                aria-label="close"
                data-test-selector="SignInDrawer_Close"
            >
                <Icon {...styles.closeIcon} color="common.accentContrast" />
            </Clickable>
            {createWidgetElement("SignIn/SignInExistingAccount", {
                fields: { ...signInExistingAccountWidgetField, isMiniSignIn: true },
            })}
            <StyledHr {...styles.divider} />
            {createWidgetElement("SignIn/SignInCreateNewAccount", {
                fields: { ...signInExistingAccountField, image: "", isMiniSignIn: true },
            })}
        </StyledWrapper>
    );
};

export default MiniSignIn;
